import useTranslation from 'hooks/useTranslation'
import React from 'react'

interface DateTileProps {
  start?: boolean
  date?: string
  disabled?: boolean
  action?: basic.BasicFunc
}

const DateTile: React.FC<DateTileProps> = ({ start = false, disabled, date, action }) => {
  const { t, lang } = useTranslation()
  const message = t('calendar.forIndefinitePeriodArray')
  const dateObject = date ? new Date(date) : undefined

  return <div
    className='calendar__input'
    onClick={disabled ? undefined : action}
    style={disabled ? { opacity: 0.5 } : undefined}>

    <div className='input__shadow'>
      <div />
      <div />
    </div>

    <div className='input__main'>
      <div>{t(`filters.${start ? 'from' : 'to'}`)}</div>
      {dateObject ? <>
        <div className='input__month'>{dateObject.toLocaleDateString(lang, { month: 'short' })}</div>
        <div className='input__day --secFont'>{dateObject.getDate()}</div>
        <hr />
        <div className='input__year'>{dateObject.getFullYear()}</div>
      </> : Array.isArray(message) ? <>
        <div className='input__month'>{message[0]}</div>
        <div className='input__day --secFont'>{message[1]}</div>
        <hr />
        <div className='input__year'>{message[2]}</div>
      </> : false}
    </div>
  </div>
}

export default DateTile